<template>
    <div>
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-card shadow="never" class="m-b-20">
                    <div slot="header" class="clearfix">
                        <h2>Регистрационные данные</h2>
                    </div>
                    <el-row :gutter="20">
                        <el-col :sm="24" :md="12" :lg="12" :xl="12">
                            <div>
                                <b>Имя пользователя:</b>
                                {{user.user.name}}
                            </div>
                            <div>
                                <b>Роль:</b>
                                Менеджер {{user.user.role}}
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-card shadow="never" class="m-b-20">
                    <div slot="header" class="clearfix">
                        <h2>Сменить пароль</h2>
                    </div>
                    <el-form v-model="model" ref="form" status-icon>
                        <el-form-item label="Введите новый пароль" prop="password">
                            <el-input type="password" v-model="model.password" placeholder="Пароль" />
                        </el-form-item>
                        <el-button type="primary" v-on:click="changePassword">Сменить пароль</el-button>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                model: {
                    password: ''
                }
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        methods: {
            changePassword () {
                let request = {
                    Name: 'ExecuteFunction',
                    ItemType: 'Customer',
                    FunctionName: 'ChangePasswordNoChecking',
                    FunctionParameters: [ sessionStorage.getItem('customerId'), this.model.password ]
                }

                this.$api.Auth.changePasswordNoChecking(request).then(response => {
                    if (response.Result === "Success") {
                        this.$message({ message: 'Пароль сменен на новый', type: 'success', res: response })
                    }
                    else {
                        this.$message({ message: response.ErrorString, type: 'error', res: response })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
